import React, { ComponentPropsWithoutRef, FC } from 'react';
import cx from 'classnames';

import { formatter } from 'helpers';
import { useLang } from 'hooks';
import { useProfileBalanceQuery } from 'hooks/queries';
import { Spin } from 'components/ui';

import styles from './styles.module.css';

type BalanceProps = ComponentPropsWithoutRef<'div'>;

const Balance: FC<BalanceProps> = ({ className, ...props }) => {
  const lang = useLang();

  const balanceQuery = useProfileBalanceQuery();

  const balance = balanceQuery.data;

  return (
    <div className={cx(styles.root, className)} {...props}>
      {balance ? (
        <div className={styles.content}>
          <div className={styles.label}>{lang.get('common.menu.balance')}</div>
          <div className={styles.value}>{formatter.formatCurrency(balance.balance, balance.currency)}</div>
        </div>
      ) : (
        <Spin />
      )}
    </div>
  );
};

export default Balance;
